import React from 'react'

function PageTitleToggle({ onChange, checked, key }) {
    return (
        <div className="col-md-6 col-lg-3 d-flex align-items-center" title="Show Page Title" >
            <label className="mb-0">
                Show Page Title <i className="fal fa-info-circle"></i>
            </label>
            <div className="toggle-switch ml-2">
                <label className="switch">
                    <input
                        type="checkbox"
                        checked={checked}
                        onChange={onChange}
                        name={key}
                    />
                    <span className="slider slider-round"></span>
                </label>
            </div>
        </div>
    )
}

export default PageTitleToggle